<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="30%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="addFormRules" ref="addFormRef" label-width="80px">
      <el-form-item label="Title" prop="title">
        <el-input v-model="formData.title"></el-input>
      </el-form-item>
      <el-form-item label="Group" prop="group_id">
        <el-select v-model="formData.group_id" placeholder="Select group" filterable>
          <el-option label="Select group" :value="0"></el-option>
          <el-option v-for="item in groupList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Sort" prop="sort">
        <el-input-number v-model="formData.sort" :min="0" :max="255"></el-input-number>
        <span style="margin-left: 10px; color: #909399; font-size: 12px;">越大越靠前</span>
      </el-form-item>
      <el-form-item label="Image" prop="pic">
        <template>
          <el-upload
            class="avatar-uploader"
            action="/proxy/upload_img222"
            name="img"
            :show-file-list="false"
            :before-upload="handleUpload"
            :on-success="handleSuccess">
            <img v-if="picUrl" :src="picUrl + '?imageView2/0/w/50'" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </template>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">Cancel</el-button>
      <el-button type="primary" @click="addConfirm">Confirm</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as qiniu from 'qiniu-js'
import md5 from 'js-md5'

const createDefaultFormData = () => ({
  title: '',
  group_id: 0,
  pic: '',
  valid_days: 0,
  sort: 0
})

export default {
  name: 'category_add',
  props: [
    'visible', 'id', 'groupList'
  ],
  data () {
    return {
      title: 'Add Category',
      uploadPrepareResp: {},
      formData: createDefaultFormData(),
      picUrl: '',
      addFormRules: {
        title: [
          { required: true, message: 'Title is required', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    resetFormData () {
      this.formData = createDefaultFormData()
      this.picUrl = ''
      this.title = 'Add Category'
    },
    closeDialog () {
      if (this.$refs.addFormRef) {
        this.$refs.addFormRef.resetFields()
        this.$refs.addFormRef.clearValidate()
      }
      this.resetFormData()
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      if (this.id > 0) {
        this.title = 'Edit Category'
        this.getInfo(this.id)
      } else {
        this.resetFormData()
      }
      this.uplodPrepare()
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/category/info/' + id)
      if (res.code === 0) {
        this.formData = {
          title: res.data.title || '',
          group_id: Number(res.data.group_id) || 0,
          pic: res.data.pic || '',
          valid_days: res.data.valid_days || 0,
          sort: Number(res.data.sort) || 0
        }
        this.picUrl = res.data.pic_url || ''
      }
    },
    async uplodPrepare () {
      const res = await this.$http.get('/admin/upload_prepare')
      if (res.code === 0) {
        this.uploadPrepareResp = res.data
      }
    },
    handleUpload (file) {
      const fileNameArr = file.name.split('.')
      const key = 'image/' + this.getDateString() + '/' + md5(file.name + Date.now()) + '.' + fileNameArr[1]
      const putExtra = { fname: key }
      const config = { useCdnDomain: true, region: qiniu.region.z0 }
      const observable = qiniu.upload(file, key, this.uploadPrepareResp.up_token, putExtra, config)
      this.uploading = 1
      const next = (res) => {
        this.upPercent = Math.ceil(res.total.percent)
      }
      const error = (err) => {
        this.$message.error(err.message)
      }
      const complete = (res) => {
        this.upPercent = 100
        this.uploading = 0
        this.formData.pic = res.key
        this.picUrl = this.uploadPrepareResp.res_domain + res.key
      }
      observable.subscribe({ next, error, complete })
      this.uplodPrepare()
      return false
    },
    getDateString () {
      const date = new Date()
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}${month}${day}`
    },
    handleSuccess (resp) {
      if (resp.code === 0) {
        this.picUrl = resp.data.url
        this.formData.pic = resp.data.path
      } else {
        this.$message.error(resp.msg)
      }
    }
  }
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}

.avatar {
  width: 50px;
  height: 50px;
  display: block;
}
</style>
